function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.3 43.843q-.958 0-1.63-.639Q0 42.55 0 41.65q0-.918.67-1.572.672-.655 1.63-.655.975 0 1.645.655.687.654.687 1.572 0 .9-.687 1.555-.671.639-1.645.639m25.54-.361h-4.154l-10.94-17.26a7.7 7.7 0 0 1-.687-1.36h-.096q.129.754.128 3.227v15.393H8.418V20h4.424l10.573 16.85q.671 1.05.862 1.442h.064q-.16-.934-.16-3.16V20h3.658zm17.888 0H32.87V20h12.346v3.308h-8.545v6.648h7.874v3.292h-7.874v6.943h9.056zM64 23.308h-6.58v20.175h-3.802V23.308h-6.564V20H64z",
    style: {
      fill: "#512bd4",
      fillOpacity: 1,
      strokeWidth: 0.198143
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.c70278ff2bd882e4946077d043d792c6.svg";
export { ForwardRef as ReactComponent };